import { CheckboxField } from "@/components/forms/CheckboxField"
import { ChoiceField } from "@/components/forms/ChoiceField"
import { Form } from "@/components/forms/Form"
import { RadioField } from "@/components/forms/RadioField"
import { Textarea } from "@/components/forms/Textarea"
import type { LicenseData } from "@/hooks/useLicenseStore"
import { useStrings } from "@/hooks/useStrings"
import { strings } from "@/strings"
import type { UseFormReturn } from "react-hook-form"
import { LicenseLogo } from "@/components/common/LicenseLogo"

type AttributionProps = {
  form: UseFormReturn<LicenseData>
}

export const Attribution = ({ form }: AttributionProps) => {
  const strings = useStrings()
  const attribution = (form.getValues() as any)?.attributionRequired === 'yes'

  return (
    <Form form={form}>

      <ChoiceField
        form={form}
        behaviour="radio"
        name="attributionRequired"
        label="Attribution required *"
        description="Is acknowledgement required for data providers?"
        options={[
          {
            title: strings.option.yes,
            description: "The data provider requires acknowledgment",
            value: "yes",
            icon: <LicenseLogo logo="attribution-yes" />
          },
          {
            title: strings.option.no,
            description: "The data provider does not require acknowledgment",
            value: "no",
            icon: <LicenseLogo logo="attribution-no" />
          },
        ]}
      />

      {attribution
        ? <>
          <ChoiceField
            form={form}
            behaviour="checkbox"
            name="attributionRequirements"
            label="Attribution requirements"
            description="What level of acknowledgment is required for data providers?"
            options={[
              {title: 'Attribution', description: 'The data provider requires attribution on any outputs using these data', value: 'attribution', icon: <LicenseLogo logo="attribution-yes" />},
              {title: 'Authorship',  description: 'The data provider requires authorship on any published outputs using these data', value: 'authorship', icon: <LicenseLogo logo="attribution-author" />},
            ]}
          />
        </>
        : <></>
      }


    </Form>
  )
}
